import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from '@/redux/agreements/actions';
import { Loader } from '@/components';
import { AgreementTypeChoices } from '@/constants/Leads';
import { dateToString } from '@/utils/common';

const AsyncAgreements = Loadable({
  loader: () => import('./Agreements'),
  loading: Loader,
});

const mapStateToProps = ({ agreements }) => ({
  ...agreements,
  tableAgreementsData: agreements.data.map((agreement, index) => {
    return Object.assign(
      {},
      {
        key: index,
        fileSigned: agreement.file_signed ? 'Yes' : 'No',
        type: AgreementTypeChoices(agreement.agreement_type),
        signedDate: dateToString(agreement.signed_datetime),
        leadId: agreement.lead,
        leadName: agreement.lead_name,
        url: agreement.sign_url,
      }
    );
  }),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAgreements: actions.fetchAgreements,
      tableChange: actions.tableChange,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncAgreements);
